import { OrbitControlsComponent } from './../../controls/orbit-controls/orbit-controls.component';
import { PerspectiveCameraComponent } from './../perspective-camera/perspective-camera.component';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  ElementRef,
  OnDestroy,
  ContentChild,
} from '@angular/core';
import { Vector2, AxesHelper, PerspectiveCamera, OrthographicCamera, Vector3 } from 'three';
import { BoundingBox2FromCenterSize } from '../../share/boundingbox2';
import { OrthographicCameraComponent } from '../orthographic-camera/orthographic-camera.component';
import { SceneService } from '../scene.service';
import { CanvasService } from '../canvas.service';
import { RendererService } from '../renderer.service';
import { MouseCanvasService } from '../../controls/mouse/mouse-canvas.service';

@Component({
  selector: 'ng3-canvas',
  templateUrl: './canvas.component.html',
  providers: [SceneService, CanvasService, RendererService, MouseCanvasService],
  styleUrls: ['./canvas.component.css'],
})
export class CanvasComponent implements OnInit, AfterViewInit, OnDestroy {
  debug = false;
  @Input()
  get size(): Vector2 {
    return this.canvasService.size.size;
  }
  set size(v: Vector2) {
    this.canvasService.size = new BoundingBox2FromCenterSize(
      new Vector2(0, 0),
      v,
    );
  }

  @ViewChild('canvas') htmlCanvas!: ElementRef<HTMLCanvasElement>;
  diagnosis = false;

  @ContentChild(OrthographicCameraComponent)
  orthographicCamera!: OrthographicCameraComponent;

  @ContentChild(PerspectiveCameraComponent)
  perspectiveCamera!: PerspectiveCameraComponent;

  @ContentChild(OrbitControlsComponent)
  orbitControls!: OrbitControlsComponent;

  get camera() {
    if (this.perspectiveCamera !== undefined) {
      return this.perspectiveCamera.camera;
    }
    if (this.orthographicCamera !== undefined) {
      return this.orthographicCamera.camera;
    }
    return undefined;
  }

  get controls () {
    if (this.orbitControls !== undefined) {
      return this.orbitControls.camera;
    }
    return undefined;
  }
  constructor(
    private elRef: ElementRef<HTMLElement>,
    private scene: SceneService,
    private canvasService: CanvasService,
    public renderer: RendererService,
    public mouse: MouseCanvasService,
  ) {
    this.elRef.nativeElement.appendChild(this.renderer.domElement);
    // console.log(this.camera);
  }

  render() {
    this.renderer.render();
  }

  ngOnInit() {
    if (this.debug) {
      const axes = new AxesHelper(1);
      this.scene.add(axes);
      this.render();
    }
  }

  ngOnDestroy() { }

  ngAfterViewInit(): void {
    if (this.camera === undefined) {
      throw Error('Camera is undefined');
    }
    // this.orbitControls.
    // this.camera.scale.set(1, 1, 0.5) ;
    // console.log(this.controls);
    this.renderer.setCamera(this.camera);
    // console.log(this.camera);
    // console.log(this.renderer.camera);
    this.render();
  }

  logScene() {
    console.log(this.scene);
    console.log(this.camera);
    console.log(this.renderer.domElement);
    console.log(this.renderer.domElement.getBoundingClientRect());
  }
}
